const NotificationAPI = {
  API_ROOT_URL: "/notification", //In ENV already
};
export default NotificationAPI;
